import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from '../environment/environment.service';
import { OSSRelocationData, OssRelocationResponse, OssRelocationResponseOld } from '@mwe/models';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OSSService {
  private http = inject(HttpClient);
  private environmentService = inject(EnvironmentService);

  public resourceUrl: string;

  constructor() {
    this.resourceUrl = this.environmentService.getApiUrl() + 'api/oss/';
  }

  async submitRelocation(changeAddressData: OSSRelocationData): Promise<OssRelocationResponse> {
    return lastValueFrom(this.http.post<OssRelocationResponse>(this.resourceUrl + 'addresschange', changeAddressData));
  }

  //TODO: remove with MWE-15853
  async submitRelocationOld(changeAddressData: OSSRelocationData): Promise<OssRelocationResponseOld> {
    return lastValueFrom(this.http.post<OssRelocationResponseOld>(this.resourceUrl + 'addresschangeOld', changeAddressData));
  }
}
